import { Component } from '@angular/core';
import { HomeService } from './services/home/home.service';
import { CategoryService } from './services/category/category.service';
import { UserService } from './services/user/user.service';
import { B2cService } from "./services/b2c/b2c.service";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'CT';
  isLoged:boolean;
  isLogedB2c:boolean;
  constructor(public userService:UserService,private categoryService:CategoryService,public b2cService:B2cService){}

  onActivate(event) {
   window.scroll({
           top: 0,
           left: 0,
           behavior: 'smooth'
    });
  }

//   onActivate(event) {
//     if(this.userService.isLoggedIn()){
//       this.isLoged =  this.userService.isLoggedIn();
//     }else if(this.b2cService.isLoggedIn()){
//       this.isLogedB2c =  this.b2cService.isLoggedIn();
//     }
//     console.log(this.isLogedB2c);

  //  window.scroll({
  //          top: 0,
  //          left: 0,
  //          behavior: 'smooth'
  //   });
//   }

//   changeLoged(event) {
//     if(this.userService.isLoggedIn()){
//       this.isLoged =  this.userService.isLoggedIn();
//     }else if(this.b2cService.isLoggedIn()){
//       this.isLogedB2c =  this.b2cService.isLoggedIn();
//     }
//  }
}
